import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const tail = css`
  margin-inline-start: auto;
`
export const root = css`
  padding: 0;
`
export const image = css`
  flex-shrink: 0;
  inline-size: ${spacing(5)};
`
export const content = css`
  flex-grow: 1;
`
export const truncate = css`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
export const withImage = css`
  inline-size: calc(100% - ${spacing(5)});
  padding-inline-start: ${spacing(1)};
`
